import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const BackwardArrow: React.FC<NormalIconProps> = (props) => (
	<svg onClick={props.onClick} viewBox="0 0 309.143 309.143" className={props.className || ''}>
		<path
			d="M112.855,154.571L240.481,26.946c2.929-2.929,2.929-7.678,0-10.606L226.339,2.197
			C224.933,0.79,223.025,0,221.036,0c-1.989,0-3.897,0.79-5.303,2.197L68.661,149.268c-2.929,2.929-2.929,7.678,0,10.606
			l147.071,147.071c1.406,1.407,3.314,2.197,5.303,2.197c1.989,0,3.897-0.79,5.303-2.197l14.142-14.143
			c2.929-2.929,2.929-7.678,0-10.606L112.855,154.571z"
		/>
	</svg>
);
